import ParamHelper from "../helpers/param.helper";
var BaseParser = /** @class */ (function () {
    function BaseParser(breakpoints, defaultOptions) {
        this.breakpoints = breakpoints;
        this.defaultOptions = defaultOptions;
    }
    /**
     * Gets the name of the descriptor.
     *
     * @param {HTMLElement} - Element that has or hasn't the name
     *
     * @returns {string | undefined} - The name if it exists
     */
    BaseParser.prototype.getName = function (el) {
        return this.get(el, "name");
    };
    /**
     * Gets all elements of [data-key] inside the container, casting nodes to @HTMLElement
     *
     * @param {HTMLElement} - Container
     *
     * @returns {HTMLElement[]} - List of [data-key] elements
     */
    BaseParser.prototype.getElements = function (container) {
        var elements = [];
        var nodes = container.querySelectorAll("[data-" + this.key + "]");
        nodes.forEach(function (node) { return elements.push(node); });
        return elements;
    };
    BaseParser.prototype.get = function (el, property) {
        return ParamHelper.get(el, this.breakpoints, this.key, property);
    };
    return BaseParser;
}());
export default BaseParser;
//# sourceMappingURL=base.parser.js.map